<template>
     <v-content>
        <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
        <v-form>
                <v-expansion-panels class="my-2" hover>
                    <v-expansion-panel>
                        <v-expansion-panel-header>{{ $t('filter') }} </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row style="justify-content:center">
                                <div class=" col-3">
                                    <v-radio-group v-model="officeTypeEN" row>

                                        <v-radio :label="$t('company')" value="Company"></v-radio>
                                        <v-radio :label="$t('branch')" value="Branch"></v-radio>
                                        <v-radio :label="$t('depo')" value="Depo"></v-radio>
                                    </v-radio-group>
                                </div>
                                <div class="col-3" v-if="officeTypeEN=='Company'">
                                    <v-autocomplete class="pa-2"
                                                    :items="listData.companyList"
                                                    item-text="value"
                                                    item-value="id"
                                                    :label="$t('company')"
                                                    required dense outlined
                                                    v-model.number="logData.companyID">
                                    </v-autocomplete>
                                </div>


                                <div class="col-3" v-if="officeTypeEN=='Branch'">
                                    <v-autocomplete class="pa-2"
                                                    :items="listData.branchList"
                                                    item-text="value"
                                                    item-value="id" dense outlined
                                                    :label="$t('branch')"
                                                    v-model.number="logData.branchID"></v-autocomplete>
                                </div>

                                <div class="col-3" v-if="officeTypeEN=='Depo'">
                                    <v-autocomplete class="pa-2"
                                                    :items="listData.depoList"
                                                    item-text="value"
                                                    item-value="id"
                                                    :label="$t('depo')" dense outlined
                                                    v-model.number="logData.depoID">
                                    </v-autocomplete>
                                </div>
                            </v-row>
                            <v-row>
                                <v-col class="col-3">

                                </v-col>
                                <v-col class="col-2">
                                    <v-autocomplete :error-messages="yearErrors"
                                                    :items="yearList"
                                                    @input="setValueYear(logData.year)"
                                                    item-text="id" dense outlined
                                                    item-value="value"
                                                    :label="$t('select_year')"
                                                    required
                                                    v-model="logData.year">
                                    </v-autocomplete>
                                </v-col>
                                <v-col class="col-4">
                                    <v-autocomplete :items="roleReportList"
                                                    item-text="value" dense outlined
                                                    item-value="id"
                                                    :label="$t('reports')"
                                                    required
                                                    v-model="logData.reportID">
                                    </v-autocomplete>
                                </v-col>
                                <v-col class="col-1">

                                </v-col>

                                <v-col class="col-2">
                                    <v-btn @click="reportLog()" class="ml-2" color="green" dark>
                                        {{$t('search')}}
                                    </v-btn>
                                    <v-btn @click="reset" class="ml-2" color="blue darken-4" dark> {{$t('reset')}}</v-btn>
                                </v-col>
                            </v-row>
                            <v-row class="float-right">
                                <div class="text-right pa-1 float-right ">
                                    <v-btn @click="exportTableToExcel('tblData')" class="white--text" color="green">{{$t('export')}}</v-btn>
                                </div>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
        </v-form>
        <table class="table tbl" id="tblData">
            <thead>
                <tr>
                    <th rowspan="1">{{$t('s_no')}}</th>
                    <th rowspan="2">{{$t('fiscal_year')}}</th>
                    <th rowspan="2">{{$t('report')}} {{$t('name')}}</th>
                    <th rowspan="2">{{$t('sub_section_name')}}</th>
                    <th rowspan="2">{{$t('budget_amount')}}</th>
                    <th rowspan="2">{{$t('expenses_amount')}}</th>
                    <th rowspan="2">{{$t('remaining_amount')}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(lD,index) in listDatas1" :key="lD.id">
                    <td>{{index+1}}</td>
                    <td>{{lD.fiscalYearName}}</td>
                    <td>{{lD.reportName}}</td>
                    <td>{{lD.subSectionName}}</td>
                    <td>{{lD.totalBudegtAmount}}</td>
                    <td>{{lD.expensesBudgetAmount}}</td>
                    <td>{{lD.remainingBudget}}</td>
                </tr>
            </tbody>
        </table>
        <br />
    </v-content>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import axios from "axios";
    import { mapGetters } from "vuex";
    //import * as XLSX from 'xlsx'

    export default {
        name: 'ReportComponent',
        watch: {
           
        },
        computed: {
            breadcrumbItems() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true
                    },
                    {
                        text: this.$t('Fiscal_Year_Budget_Expenses_Report'),
                        disabled: true,
                    },
                ]
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                    errors.push("Year is required.");
                return errors;
            },
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
        },
        //props: ['companyData'],
        components: {
          
        },
        data() {
            return {
                officeTypeEN: "Company",
                listDatas1:[],
                roleReportList: [],
                // currentYear: new Date().getFullYear(),
                listData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                
                 logData: {
                    companyID: 0,
                    //departmentID: 0,
                    branchID: 0,
                    depoID: 0,
                    reportID: 0,
                     year: "2081",
                    //reportLogID: 0,
                    //isActive: null,
                    officeTypeEN: ""
                },
                yearList: [],
                userData: this.$store.getters.getUserData,
            }
        },
       
        validations: {
            logData: {
                companyID: {required},
                year: {required},
            }
            },

        mounted() {
                    this.loadCrumb()
                    this.loadData()
                    this.getDdlData()
                },

        methods: {
            getDdlData() {
                axios.get("Branch/DDLAllBranchList").then(response => {
                    this.listData.branchList = response.data
                })
                axios.get("Depo/DDLAllDepoList").then(response => {
                    this.listData.depoList = response.data
                })
            },
            loadData() {
                axios.get('Company/DDLCompanyList').then(response => {
                    this.listData.companyList = response.data
                })
            },
            loadCrumb() {
                if (this.role == "Company") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.logData.companyID, 'company')
                }
                else if (this.role == "Branch") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.logData.companyID, 'company')
                    this.logData.branchID = parseInt(this.userData.branchID)
                    this.getDdlData(this.logData.branchID, 'branch')
                }
                else if (this.role == "Depo") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.logData.companyID, 'company')
                    this.logData.branchID = parseInt(this.userData.branchID)
                    this.getDdlData(this.logData.branchID, 'branch')
                    this.logData.depoID = parseInt(this.userData.depoID)
                    this.getDdlData(this.logData.branchID, 'depo')
                }
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                })

                axios.get('ReportSettings/DDLReportList').then(response => {
                    this.reportList = response.data
                })
                axios.get("ReportSettings/GetRoleWiseReportList/" + this.userData.departmentID).then(response => {
                    this.roleReportList = response.data
                })

                this.breadCrumbs = [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: `${this.userData.dashBoardBranchUser}`,
                        exact: true
                    },
                    {
                        text: 'Profile',
                        disabled: true,
                    },
                ]
            },
            reportLog() {
                //this.$nextTick(() => {
                //    this.$v.$reset()
                //})
                let param = {
                    reportID: isNaN(this.logData.reportID) ? 0 : parseInt(this.logData.reportID),
                    companyID: parseInt(this.logData.companyID),
                    branchID: parseInt(this.logData.branchID),
                    depoID: parseInt(this.logData.depoID),                    
                    fiscalYearID: parseInt(this.logData.year),
                    OfficeType: this.officeTypeEN
                };
                
                axios.post("ReportSettings/GetFiscalYearBudegtExpensesReport", param).then(response => {
                    this.listDatas1 = response.data
                })
            },
            reset() {
                let reportID = this.logData.reportID
                this.logData = {
                    companyID: null,
                    //departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: reportID,
                    year: "",
                    //reportLogID: 0,
                    officeTypeEN:""
                },
                    this.status = {
                        isCompany: false,
                        isDepartment: false,
                    }
                this.selectedStatus = {
                    company: "",
                    branch: ""
                }
                this.$nextTick(() => {
                    this.$v.$reset()
                })
            },
            exportTableToExcel(tableID, filename = '') {
                var downloadLink;
                var dataType = 'application/vnd.ms-excel';
                var tableSelect = document.getElementById(tableID);
                var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

                // Specify file name
                filename = filename ? filename + '.xls' : 'excel_data.xls';

                // Create download link element
                downloadLink = document.createElement("a");

                document.body.appendChild(downloadLink);

                if (navigator.msSaveOrOpenBlob) {
                    var blob = new Blob(['\ufeff', tableHTML], {
                        type: dataType
                    });
                    navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // Create a link to the file
                    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

                    // Setting the file name
                    downloadLink.download = filename;

                    //triggering the function
                    downloadLink.click();
                }
            },
            setValueYear(data) {
                var year = this.yearList.filter(function (item) {
                    return item.value === data;
                });
                this.setYearValue = year[0].id;
            }
        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }
    .tbl th {
        padding-top: 20px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

</style>
